import React, { Component } from 'react';
import { connect } from 'react-redux';
import { GeckoField, GECKO_CONSTS } from '../../ui';
import './index.scss';
import { stringToHexColour } from 'utilities/colours';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';

export class TagOption extends Component {
  componentDidMount() {
    const selectValueElem = this.elem.parentElement;
    selectValueElem.style.borderBottom = `4px solid ${
      this.props.colour || '#000'
    }`;
  }

  render() {
    return (
      <span className="TagSelect-TagOption" ref={(elem) => (this.elem = elem)}>
        <span>
          {this.props.ai_generated && (
            <i className="fas fa-sparkles ai-gradient"></i>
          )}
          {this.props.name}
        </span>
      </span>
    );
  }
}

export class TagValue extends Component {
  componentDidMount() {
    const selectValueElem = this.elem.parentElement.parentElement;
    selectValueElem.style.borderBottom = `2px solid ${
      this.props.colour || '#000'
    }`;
  }

  render() {
    return (
      <span className="TagSelect-TagOption" ref={(elem) => (this.elem = elem)}>
        <span>{this.props.name}</span>
      </span>
    );
  }
}

export class TagSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderOption(option) {
    return <TagOption {...option.tag} />;
  }

  renderValue(option) {
    return <TagValue {...option.tag} />;
  }

  validateOption(option) {
    const tags = this.props.tags;
    if (!option?.label) {
      return false;
    }

    if (!tags?.length) {
      return true;
    }

    return (
      tags.findIndex(
        (tag) =>
          tag.name.toLowerCase().trim() === option.label.toLowerCase().trim()
      ) === -1
    );
  }

  field() {
    let type = GECKO_CONSTS.FIELD_TYPE_SELECT;
    if (this.props.multi) {
      type = GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI;
    }
    if (this.props.multi && this.props.create) {
      type = GECKO_CONSTS.FIELD_TYPE_SELECT_CREATE_MULTI;
    }
    return {
      key: 'value',
      type: type,
      options: this.props.tags
        .filter((tag) => this.props.showAITags || !tag.ai_generated)
        .map((tag) => {
          return {
            tag: tag,
            label: tag.name,
            value: tag.id,
          };
        }),
      config: Object.assign(
        {
          placeholder: this.props.placeholder || 'Add a tag',
          optionRenderer: this.renderOption.bind(this),
          valueRenderer: this.renderValue.bind(this),
          isValidNewOption: this.validateOption.bind(this),
          promptTextCreator: (label) => {
            return `Create new tag "${label}"`;
          },
          newOptionCreator: (data) => {
            const tag = { name: data.label };
            return Object.assign({}, data, { tag });
          },
          onNewOptionClick: (data) => {
            const tag = Object.assign({}, data.tag, {
              colour: stringToHexColour(data.tag.name),
            });
            GeckoRequest.post('/models/tags', tag)
              .then((newTag) => {
                this.props.onChange(this.props.value.concat(newTag.id));
              })
              .catch(renderError);
          },
        },
        this.props.config || {}
      ),
    };
  }

  handleChange(_key, value) {
    this.props.onChange(value);
  }

  render() {
    const values = { value: this.props.value };
    return (
      <div className="TagSelect">
        <GeckoField
          field={this.field()}
          values={values}
          handler={this.handleChange.bind(this)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    tags: props.tags || state.tags,
  };
};
export default connect(mapStateToProps)(TagSelect);
